import { cloneDeep, differenceBy } from 'lodash-es'
import { Message, MessageBox } from 'element-ui'
import albumService from '@/api/album.js'
import { clearEmptyKey } from '@/utils/objUtil'

function genReg(brackets) {
  return new RegExp(`(?<=${brackets[0]})[^${brackets[1]}]+`)
}
const brackets = [['\\(', '\\)'], ['\\[', '\\]'], ['《', '》'], ['【', '】'], ['（', '）']]

export const validateError = {
  trackErrorVersionList: [
    '抖音版', '快手版', '先行版', 'AI版', 'DJ版', '原版', '试听版', 'mv版', 'DJ版剪辑版', '剪辑版', 'penbeat版', 'djwave版', '改版', '女版', '男版', '吉他版', '通常版', '韩文版', '电音版', '完整版',
    'FC版', '消音版', '大叔版', '现场版', '翻唱版', '木兰版', '升调版', '青衣版', '慢版', '快版', '视频版', '动画版', 'Acapella版', 'Animenz版', '音乐版', '钢琴版', '陶笛版', 'AC版', 'Mark III版',
    'live', 'TV Edit', 'Demo', 'Mix', 'Remix', 'karaoke', 'in the style of', 'Instrumental', 'Instrumental Ver.', 'Inst.', 'nst. Ver.', 'Off Vocal Ver.', '黑胶版', 'Acoustic', 'remaster',
    'explicit', 'reprise', 'Jam Version', 'unplugged', 'extended', 'acapella', 'TV Version', '新版', '热播版', '环绕版', '纯享版', '加冕版', 'AOUT版', '拉拉版', '英文版', '咚鼓版', '咕咚版',
    '弹鼓版', '男生版', '女生版', '雷神版', '口水版', '最火版', '电摇版', '改编版', '说唱版', '终极版', '合唱版', '越南鼓'
  ].map(item => item.toLowerCase()),
  bracketRegs: brackets.map(genReg),
  versionErrorList: [
    'radio', 'Concert', 'Live Version', 'TV-size', 'Disco', 'Dub', 'Rmx', 'DJ', 'off vocal', 'Back Track', 'カラオケ', 'LP', 'remastered', 'revival', 'clean', 'performance', '抖音',
    '正版', '绝版', '重低音', '爆火', '快手'
  ].map(item => item.toLowerCase()),
  moiveErrorList: [
    'from', '电视剧', '电影', '映画'
  ],
  seriesErrorList: [
    '|', '/', '\\', ';'
  ]
}

export const fileFieldConfigList = [
  {
    key: 'audioFileList',
    label: '录音文件'
  },
  {
    key: 'actorFileList',
    label: '表演者文件'
  },
  {
    key: 'wordFileList',
    label: '词版权证明文件'
  },
  {
    key: 'musicFileList',
    label: '曲版权证明文件'
  },
  {
    key: 'payFileList',
    label: '付费模式文件'
  }
]
/**
 * 比较新旧对象有修改的key并生成一个修改记录对象
 * @param {*} oldObj
 * @param {*} newObj
 * @param {*} diffKeys
 * @returns
 */
export function getDiffObj(oldObj, newObj, diffKeys) {
  const res = {}
  for (const key of diffKeys) {
    if (oldObj.hasOwnProperty(key) && newObj.hasOwnProperty(key) && oldObj[key] !== newObj[key]) {
      res[key] = { oldVal: oldObj[key], newVal: newObj[key] }
    }
  }

  return Object.keys(res).length ? res : null
}

/**
 * 比较新旧数组，生成增删数组
 * @param {*} oldList
 * @param {*} newList
 * @returns
 */
export function diffArray(oldList = [], newList = []) {
  const delList = differenceBy(oldList, newList, 'id')
  const addList = newList.filter(v => !v.id)
  const res = []

  // 变更
  if (delList.length && addList.length) {
    res.push({ modifyRecord: { oldVal: JSON.stringify(cloneDeep(delList)), newVal: JSON.stringify(cloneDeep(addList)) } })
  } else if (delList.length) { // 纯删除
    res.push({ rmRecord: { oldVal: JSON.stringify(cloneDeep(delList)), newVal: '' } })
  } else if (addList.length) { // 纯新增
    res.push({ newRecord: { oldVal: '', newVal: JSON.stringify(cloneDeep(addList)) } })
  }

  return res.length ? res : undefined
}

export function checkModify(trackObj) {
  const oldLockObj = trackObj.oldLockObj
  const {
    trackPayment,
    trackExtend,
    trackLyricistList,
    trackComposerList,
    media,
    lyricData
  } = trackObj
  const modifyObj = {}
  const trackLicenseList = []

  // 获取修改了需要审核的字段的上传的文件
  fileFieldConfigList.forEach((config, index) => {
    if (trackObj[config.key] && trackObj[config.key].length) {
      trackObj[config.key].forEach(file => {
        trackLicenseList.push({
          type: index,
          ...file
        })
      })
      delete trackObj[config.key]
    }
  })
  // 获取修改了需要审核的字段的上传的文件 end

  // 基础信息
  const baseDiffObj = getDiffObj(oldLockObj, trackObj, ['firstPublicTime', 'trackName', 'transName', 'srcVersion', 'publicTime'])
  if (baseDiffObj) {
    modifyObj.track = {
      id: trackObj.trackId,
      ...baseDiffObj
    }
  }

  // 付费
  if (
    oldLockObj.trackPayment.paymentMode !== trackPayment.paymentMode ||
    oldLockObj.trackPayment.freeDuration !== trackPayment.freeDuration
  ) {
    modifyObj.trackPayment = {
      id: oldLockObj.trackPayment.id,
      paymentMode: { oldVal: oldLockObj.trackPayment.paymentMode, newVal: trackPayment.paymentMode },
      freeDuration: trackPayment.freeDuration
    }
  }

  // 扩展字段
  const extendDiffObj = getDiffObj(oldLockObj.trackExtend, trackExtend, ['subTitle', 'wordAuthor', 'musicAuthor'])
  if (extendDiffObj) {
    modifyObj.trackExtend = {
      id: trackObj.trackId,
      ...extendDiffObj
    }
  }

  // 作词ID
  modifyObj.trackLyricistList = diffArray(oldLockObj.trackLyricistList, trackLyricistList)

  // 作曲ID
  modifyObj.trackComposerList = diffArray(oldLockObj.trackComposerList, trackComposerList)

  // 音频
  if (media) {
    if (oldLockObj.media && !media.mediaId) {
      modifyObj.media = {
        modifyRecord: { newVal: JSON.stringify(cloneDeep(media)), oldVal: JSON.stringify(cloneDeep(oldLockObj.media)) }
      }
    } else if (!oldLockObj.media && !media.mediaId) {
      modifyObj.media = {
        newRecord: { newVal: JSON.stringify(cloneDeep(media)), oldVal: '' }
      }
    }
  }

  // 歌词
  modifyObj.lyricData = {}
  for (const key of Object.keys(lyricData)) {
    const newData = lyricData[key]
    const oldData = oldLockObj.lyricData[key]

    if (!newData && !oldData) continue

    // 修改
    if (oldData && !newData.lyricId) {
      modifyObj.lyricData[key] = {
        modifyRecord: { newVal: JSON.stringify(cloneDeep(newData)), oldVal: JSON.stringify(cloneDeep(oldData)) }
      }
    } else if (!oldData && !newData.lyricId) { // 新增
      modifyObj.lyricData[key] = {
        newRecord: { newVal: JSON.stringify(cloneDeep(newData)), oldVal: '' }
      }
    } else if (oldData && !newData) { // 删除
      modifyObj.lyricData[key] = {
        rmRecord: { newVal: '', oldVal: JSON.stringify(cloneDeep(oldData)) }
      }
    }
  }
  modifyObj.lyricData = Object.keys(modifyObj.lyricData).length ? modifyObj.lyricData : undefined

  if (clearEmptyKey(modifyObj)) {
    modifyObj.trackLicenseList = trackLicenseList
    modifyObj.trackId = trackObj.trackId

    return modifyObj
  }
}

export function applyModify(modifyObj) {
  return albumService.applyModifyTrack(modifyObj).catch(error => {
    Message.error(`提交字段修改请求异常(${error.message})`)
  })
}

export function checkModifySensitive(modifyObj) {
  return albumService.checkModifySensitive({
    fType: 1,
    ...modifyObj
  }).then(({ checkSign, res }) => {
    if (!checkSign) {
      throw new Error(`输入包含敏感词! ${JSON.stringify(res)}`)
    }
  }).catch(error => {
    MessageBox.alert(error.message, '错误', {
      type: 'error'
    })

    throw error
  })
}

export async function checkAndApplyModify(trackObj) {
  const modifyObj = checkModify(trackObj)
  if (modifyObj) {
    // 校验敏感词
    await checkModifySensitive(modifyObj)

    return applyModify(modifyObj)
  }
}
